/* eslint-disable no-restricted-properties */
import { LngLat, Point } from 'mapbox-gl';

export function lngLatToPoint(
  lngLat: LngLat,
  mapWidth: number,
  mapHeight: number
): Point {
  const x = (lngLat.lng + 180) * (mapWidth / 360);
  const latRad = (lngLat.lat * Math.PI) / 180;
  const mercN = Math.log(Math.tan(Math.PI / 4 + latRad / 2));
  const y = mapHeight / 2 - (mapWidth * mercN) / (2 * Math.PI);
  return new Point(x, y);
}

export function pointToLngLat(
  point: Point,
  mapWidth: number,
  mapHeight: number
): LngLat {
  const lng = (point.x / mapWidth) * 360 - 180;
  const lat =
    90 *
    (-1 +
      (4 *
        Math.atan(
          Math.pow(Math.E, Math.PI - (2 * Math.PI * point.y) / mapHeight)
        )) /
        Math.PI);
  return new LngLat(lng, lat);
}
